import { FC } from 'react'
import { LoginForm, type LoginFormProps } from '../LoginForm'
import { Loader } from '../../Loader'
import { useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'
import { useIsMobile } from '@wellesley/ui'
import { useRedirectAfterAuth } from '../../../hooks/useAuthRedirect'

const Mobile: FC<Pick<LoginFormProps, 'showSignupLink'>> = ({
  showSignupLink,
}) => <LoginForm showSignupLink={showSignupLink} />

const Desktop: FC<Pick<LoginFormProps, 'showSignupLink'>> = ({
  showSignupLink,
}) => <LoginForm showSignupLink={showSignupLink} />

export const LoginSection: FC<Pick<LoginFormProps, 'showSignupLink'>> = ({
  showSignupLink,
}) => {
  const isMobile = useIsMobile()
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  useRedirectAfterAuth()

  if (isLogged)
    return (
      <div className="flex min-h-[300px] items-center justify-center py-xxxl">
        <Loader />
      </div>
    )

  return isMobile ? <Mobile /> : <Desktop showSignupLink={showSignupLink} />
}
